module.exports = __webpack_public_path__ + "img/5.2426cc38.jpg";